import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CLARITY_PROJECT_ID, ensureClarityLoaded } from '../utils/clarity';

/**
 * Loads Microsoft Clarity only when mounted.
 * Intended to be rendered only on the `/qq/*` route.
 */
export default function QQClarity() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/qq')) return;
    ensureClarityLoaded(CLARITY_PROJECT_ID);
  }, [location.pathname]);

  return null;
}
